module.exports = __webpack_public_path__ + "static/media/cross-red-big.6f008789.svg";